import React, { useMemo } from 'react';

import { useCalendarQueries } from '@entities/сalendar/lib/useCalendarQueries';
import { DateHelpers } from '@shared/helpers';

import { TCalendarRange } from '../../model/types';

interface IUseDateRangePickerCalendarProps {
    calendarRange: TCalendarRange;
    setCalendarRange: React.Dispatch<React.SetStateAction<TCalendarRange>>;
    handlePeriodInputChange: (value: string) => void;
}

export const useDateRangePickerCalendar = ({
    calendarRange,
    setCalendarRange,
    handlePeriodInputChange,
}: IUseDateRangePickerCalendarProps) => {
    const { setDateFromQueryValue, setDateToQueryValue } = useCalendarQueries();
    const { getToday, getMinDate, getCurrentMonth, getSafeOpenToDate, dateFormatter } = DateHelpers;

    const minDate = getMinDate();
    const maxDate = getToday();
    const fallback = getCurrentMonth();

    const openToDate = useMemo(
        () => getSafeOpenToDate(calendarRange[0], minDate, maxDate, fallback),
        [calendarRange, minDate, maxDate, fallback, getSafeOpenToDate]
    );
    const handleCalendarChange = (range: [Date | null, Date | null]) => {
        setCalendarRange(range);

        const [start, end] = range;
        const format = (date: Date | null) => (date ? dateFormatter({ date }) : '');

        handlePeriodInputChange(`${format(start)} - ${format(end)}`);

        if (start && end) {
            void setDateFromQueryValue(format(start));
            void setDateToQueryValue(format(end));
        }
    };

    return {
        openToDate,
        handleCalendarChange,
        getToday,
        getMinDate,
    };
};
